/* global GEO_VERSION */

/**
 * The current geojs version.
 *
 * @alias geo.version
 * @constant
 * @type {string}
 */
module.exports = GEO_VERSION;
